<template>
    <div class="home">
      <myheader></myheader>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in banners" :key="index" @click="ToLink(item)">
          <img class="user-poster" :src="item.image_url">
        </van-swipe-item>
      </van-swipe>
      <section>
        <h1 style="font-size: 1.2rem; color: #333333; font-weight: normal; text-align: center;">关于我们</h1>
        <hr width="10%" style="border: 1px solid #000;">
        <div class="about_content" v-html="about">
        </div>
        <div class="more">
          <van-button round plain @click="ToAbout">查看更多</van-button>
        </div>
      </section>
      <section>
        <h1 style="font-size: 1.2rem; color: #333333; font-weight: normal; text-align: center;">新闻资讯</h1>
        <hr width="10%" style="border: 1px solid #000;">
        <div class="news_content">
          <template v-for="(item, index) in news">
            <van-cell :key="index" style="margin: 0 0 10px 0; padding: 0 0 10px 0;" @click="ToDetail(item)">
              <van-row :key="index">
                <van-col span="6">
                  <van-image :src="item.image ? item.image.url : ''" height="3.6rem"/>
                </van-col>
                <van-col span="18" style="padding-left: 1rem;">
                  <h3 class="act_list_x_t">{{ item.title }}</h3>
                  <p class="act_list_x_d">{{item.description}}</p>
                  <span>{{ item.created_at }}</span>
                </van-col>
              </van-row>
            </van-cell>
          </template>
        </div>
        <div class="more">
          <van-button round plain @click="ToNews">查看更多</van-button>
        </div>
      </section>
<!--      <section>
        <h1 style="text-align: center; font-size: 1.2rem; font-weight: normal;">服务项目 · 大市场</h1>
        <van-grid :border="false" :column-num="2">
          <van-grid-item>
            <van-image src="/img/servicea.png" width="4.5rem" />
            <h2 style="font-size: 0.9rem; font-weight: normal; color: #333333;">成品网站</h2>
            <span style="font-size: 0.66rem; color: #666666">上百套精美模板随意挑选</span>
          </van-grid-item>
          <van-grid-item>
            <van-image src="/img/serviceb.png" width="4.5rem" />
            <h2 style="font-size: 0.9rem; font-weight: normal; color: #333333;">营销型网站</h2>
            <span style="font-size: 0.66rem; color: #666666">量身定制，针对性策划方案</span>
          </van-grid-item>
          <van-grid-item>
            <van-image src="/img/serviced.png" width="4.5rem" />
            <h2 style="font-size: 0.9rem; font-weight: normal; color: #333333;">搜狗竞价</h2>
            <span style="font-size: 0.66rem; color: #666666">安徽地区搜狗推广战略伙伴</span>
          </van-grid-item>
          <van-grid-item>
            <van-image src="/img/serviced.png" width="4.5rem" />
            <h2 style="font-size: 0.9rem; font-weight: normal; color: #333333;">网站优化</h2>
            <span style="font-size: 0.66rem; color: #666666">最快7天达标，按天扣费更放心</span>
          </van-grid-item>
        </van-grid>
      </section>-->
      <myfooter></myfooter>
    </div>
</template>
<script>
  import { Field, Button, Cell, CellGroup, Toast, Swipe, SwipeItem, Image, Row, Col, Grid, GridItem } from 'vant'
  import { getAboutHome, getBannerList, getNewsList } from '@/api'

  export default {
    name: 'index',
    components: {
      [Field.name]: Field,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Image.name]: Image,
      [Row.name]: Row,
      [Col.name]: Col,
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Button.name]: Button,
    },
    data () {
      return {
        banners: [],
        news: [],
        about: ''
      }
    },
    methods: {
      ToAbout() {
        this.$router.push({path: '/about'})
      },
      ToNews() {
        this.$router.push({path: '/news'})
      },
      getAboutHome() {
        getAboutHome().then(res => {
          this.about = res
        })
      },
      getNewsList() {
        getNewsList({flag: 1, size: 3}).then(res => {
          this.news = res.data.data
        })
      },
      getBannerList() {
        getBannerList().then(res => {
          this.banners = res.data
        })
      },
      ToLink(item) {
        if(item.link){
          location.href = item.link
        }
      }
    },
    mounted () {
      this.getBannerList()
      this.getAboutHome()
      this.getNewsList()
    }
  }
</script>
<style lang="less">
    .user {
        &-poster {
            width: 100%;
            height: 53vw;
            display: block;
        }
        &-group {
            margin-bottom: 15px;
        }
        &-links {
            padding: 15px 0;
            font-size: 12px;
            text-align: center;
            background-color: #fff;
            .van-icon {
                display: block;
                font-size: 24px;
            }
        }
    }
    .my-swipe .van-swipe-item {
      width: 100%;
      .van-image{
        height: 13rem;
      }

      /*color: #fff;*/
      /*font-size: 20px;*/
      /*line-height: 150px;*/
      /*text-align: center;*/
      /*background-color: #39a9ed;*/
    }
    .home .van-cell-group__title{
      padding: 0;
    }
    .about_content {
      padding: 1rem 1.5rem 0.3rem 1.5rem;
      font-size: 0.78rem;
      font-weight: normal;
      color: #666666;
      line-height: 1.2rem;
    }
    .more{
      text-align: center;
    }
    .news_content {
      padding: 1rem 1.5rem 0.3rem 1.5rem;
      font-size: 0.78rem;
      font-weight: normal;
      color: #666666;
      line-height: 1.2rem;
    }
    .act_list_x_t {
      font-size: 0.84rem;
      margin: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
    }
    .act_list_x_d {
      font-size: 0.66rem;
      margin-top: 0.05rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 0.1rem;
      color: #999999;
    }
</style>
